/**
 * First-touch attribution
 *
 * Records the very first page a visitor lands on and persists it across
 * sessions in localStorage. GA4 natively captures first-user source/medium but
 * NOT the first landing page URL, so we surface it as a user property.
 *
 * Path only (no query string): marketing params (utm_*, gclid, …) are already
 * captured by GA4's native source dimensions, so the query string would just be
 * noise here.
 */

export const FIRST_LANDING_PAGE_KEY = 'cp_first_landing_page';

/**
 * Record the current pathname as the first landing page, once. Never
 * overwrites an existing value, so a value captured while anonymous survives
 * until the visitor later logs in and identify() runs.
 */
export function captureFirstLandingPage(): void {
  if (typeof window === 'undefined') return;
  try {
    if (localStorage.getItem(FIRST_LANDING_PAGE_KEY) == null) {
      localStorage.setItem(FIRST_LANDING_PAGE_KEY, window.location.pathname);
    }
  } catch {
    // localStorage can throw (private mode, quota). First-touch is best-effort.
  }
}

/** The first landing page path, or null if none has been captured. */
export function getFirstLandingPage(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem(FIRST_LANDING_PAGE_KEY);
  } catch {
    return null;
  }
}
